import { render, staticRenderFns } from "./SettingSection.vue?vue&type=template&id=c1c0ed02"
import script from "./SettingSection.vue?vue&type=script&lang=js"
export * from "./SettingSection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports